<template>
  <el-form-item
    :label="form.name"
    :prop="form.model"
    :class="[form.options.required?'label-blue':'']"
    :rules="form.rules"
    :required="form.options.required"
    v-show="!form.options.hidden"
  >
   <el-upload
  class="upload-demo"
  :ref='refName'
  :action="actionUrl"
  :file-list="fileList"
  :show-file-list="false"
  :on-progress="onProgress"
  :on-success='successHandle'
  multiple>
       <el-button  icon="el-icon-plus" size="small" type="primary"   :disabled="inputDisable" :loading="uploadLoading">{{uploadLoading?'上传中':'点击上传'}}</el-button>
   </el-upload>
      <div>
          <div v-for="(item,index) in fileList" :key="index">
              <span><i class="el-icon-document"></i>{{item.name}}</span>
              <span @click="onRemove(index)" style="color: #ff0000;margin-left: 5px;cursor: pointer;" v-if="inputDisable">[删除]</span>
              <span @click="downLoad(item.url)" style="color: #00aeef;margin-left: 5px;cursor: pointer;">[下载]</span>
          </div>
      </div>
  </el-form-item>
</template>

<script>
import util from "@/libs/util";

export default {
  name: "DynamicFilesUpload",
  data() {
    let url = this.$url.uploadfiles
    return {
        actionUrl: url,
        myHeaders:{

        },
        params: {
            path: ''
        },
        uploadLoading:false,
        fileHttp: "",
      key: "",
      formData: {},
      mainValue: "",
      refName:'',
      uploadUrl:'',
      fileList:[]
    };
  },
  props: {
    form: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
          options: {
            defaultValue: [],
            width: "",
            tip: "文件类型为Word,PDF等主流文件",
            action: "https://jsonplaceholder.typicode.com/photos/",
            customClass: "",
            disabled: false,
            limit: 9,
            fileList: [],
            labelWidth: 100,
            isLabelWidth: false,
            hidden: false,
            dataBind: true,
            remoteFunc: "func_1573098714232"
          },
          name: "文件",
          novalid: {},
          key: "1573098714232",
          model: "fileupload_1573098714232",
          rules: []
        };
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "value",
    event: "input"
  },
  watch: {
    value: {
      immediate: true,
      handler: function(val, oldVal) {
        let that = this
        this.mainValue = val;
      }
    }
  },
  methods: {
    onInput() {
      let that = this;
      that.$emit("input", that.value, that.form.model);
      if (typeof that.form.options.changeFunc === "function") {
        // 判断是否存在数据改变事件
        that.form.options.changeFunc(
          that.value[that.form.model],
          that,
          that.forms
        );
      }
    },
      getUserToken(){
          let token = util.session.get("token")
          this.myHeaders = {
              userToken:token
          }
      },
      onProgress(event, file, fileList){
          this.uploadLoading = true
      },
    //验证是否是图片
     beforeAvatarUpload(file) {

          var isFile;
        var imgType= file.name.substring(file.name.lastIndexOf('.')+1)

        switch(imgType){
          case 'doc':
            isFile = true
            break;
          case 'docx':
            isFile = true
            break;
          default:
            isFile = false
        }
        if (!isFile) {
          this.$message.error(this.form.options.tip?this.form.options.tip:'文件类型为Word,PDF等主流文件');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 2MB!');
        }
        return isFile && isLt2M;
      },
      successHandle(response, file, fileList) {
          if (response.resultCode !== 2000) {
              this.fileList = []
              this.uploadLoading = false
              this.$message.error("文件上传失败")
          } else {

              this.uploadLoading = false
              let data = JSON.parse(response.data)
              let img = data.img
              let fileUrl = img.substring(0, img.length - 1)
              this.thisFileUrl =  fileUrl
              let list = [{name: file.name, url: this.thisFileUrl}]
              this.fileList = list
              if (typeof this.fileList === 'undefined' || this.fileList.length === 0){
                  this.$emit('input', '')
              }else{
                  this.$emit('input', JSON.stringify(this.fileList))
              }
          }
      },
      handlePreview(file) {
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      }
  },
  created() {
    let that = this;
    that.key = that.form.key;
    if (that.form.hasOwnProperty("options")) {
      that.value[that.form.model] =
        that.value[that.form.model] ||
        this.form["options"]["defaultValue"] ||
        "";
    }
    this.uploadUrl = this.$url.uploadfiles
    this.refName = 'upload' + new Date().getTime()
  },
  mounted() {
    let that = this;
    that.$emit("init", that.key, that);
      this.getConfigUrl().then(res => {
          this.getUserToken()
          this.fileHttp = res
          this.params.path = this.path
      })
  },
  computed: {
    inputDisable() {
      return this.disabled || this.form.options.disabled;
    }
  }
};
</script>

<style scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Form/DynamicFilesUpload.vue"
}
</vue-filename-injector>
